export default {
  // 頁面標題
  title: '建立活動',
  editTitle: '編輯活動',
  // 步驟標題
  step1: '基本資訊',
  step2: '活動範圍',
  step3: '活動獎項',
  step4: '活動策略',
  // 步驟1 - 基本資訊
  activityName: '活動名稱',
  activityNameRequired: '請輸入活動名稱',
  activityNamePlaceholder: '請輸入活動名稱',
  activityTime: '活動時間期間',
  activityTimeRequired: '請選擇活動時間期間',
  startTime: '開始時間',
  endTime: '結束時間',
  activityTemplate: '活動模板',
  activityTemplateRequired: '請選擇活動模板',
  activityTemplatePlaceholder: '請選擇活動模板',
  addTemplate: '+活動模板',
  activityRule: '活動規則',
  rulePlaceholder: '請輸入活動規則',
  activityRemark: '活動備註',
  remarkPlaceholder: '請輸入活動備註',
  // 步驟2 - 活動範圍
  addCode: '添加二維碼',
  addCodeTitle: '添加二維碼',
  selectCodePlaceholder: '請選擇二維碼',
  codeEmptyText: '暫無二維碼數據',
  codeBatch: '碼批次',
  codeRange: '二維碼範圍',
  codeCount: '二維碼數量',
  scopeRemark: '活動範圍備註',
  colAction: '操作',
  deleteCode: '刪除',
  codeBatchRequired: '請選擇碼批次',
  codeBatchPlaceholder: '請選擇碼批次',
  selectCodeBatch: '選擇碼批次',
  codeRangeType: 'QR Code範圍',
  codeRangeTypeRequired: '請選擇QR Code範圍',
  rangeAll: '整批添加',
  rangePartial: '部分添加',
  rangePartialSerial: '部分添加（流水號區間）',
  rangePartialId: '部分添加（ID區間）',
  codeRangeRequired: '請輸入QR Code範圍',
  serialRange: '流水號區間',
  idRange: '二維碼ID區間',
  serialStartPlaceholder: '開始流水號',
  serialEndPlaceholder: '結束流水號',
  idStartPlaceholder: '開始ID',
  idEndPlaceholder: '結束ID',
  rangeStartPlaceholder: '開始序號',
  rangeEndPlaceholder: '結束序號',
  scopeRemarkPlaceholder: '請輸入活動範圍備註',
  invalidRange: '結束序號必須大於開始序號',
  serialRangeInvalid: '開始流水號不得大於結束流水號',
  confirmDeleteRange: '確認刪除該活動範圍？',
  codeBatchNo: '批次號',
  codeBatchName: '批次名稱',
  // 步驟3 - 活動獎項
  addPrize: '添加獎項',
  addPrizeTitle: '添加獎項',
  editPrizeTitle: '編輯獎項',
  editPrize: '編輯',
  deletePrize: '刪除',
  confirmDeletePrize: '確認刪除該獎項？',
  prizeEmptyText: '暫無獎項數據',
  prizeName: '獎項名稱',
  prizeNameRequired: '請輸入獎項名稱',
  prizeNamePlaceholder: '請輸入獎項名稱',
  prizeProbability: '中獎概率',
  prizeProbabilityPlaceholder: '請輸入中獎概率',
  prizeCount: '獎品數量',
  prizeCountPlaceholder: '請輸入獎品數量',
  prizeContent: '獎項內容',
  pointsLabel: '積分',
  giftLabel: '禮品',
  strategyOnly: '僅策略中獎',
  prizeImage: '獎項圖片',
  prizePoints: '積分',
  prizeGift: '禮品名稱',
  prizeGiftPlaceholder: '請選擇禮品',
  prizeIcon: '獎項圖標',
  prizeIconRequired: '請上傳獎項圖標',
  prizePointsPlaceholder: '請輸入積分數量',
  prizeProbabilityRequired: '請輸入中獎概率',
  prizeCountRequired: '請輸入獎品數量',
  prizeContentRequired: '請至少選擇一項獎項內容',
  prizeGiftRequired: '請選擇禮品',
  prizePointsRequired: '請輸入積分數量',
  selectGift: '選擇禮品',
  giftNameCol: '禮品名稱',
  giftCategoryCol: '禮品分類',
  // 步驟4 - 活動策略
  addStrategy: '添加策略',
  addStrategyTitle: '添加策略',
  editStrategyTitle: '編輯策略',
  editStrategy: '編輯',
  deleteStrategy: '刪除',
  confirmDeleteStrategy: '確認刪除該策略？',
  strategyEmptyText: '暫無策略數據',
  strategyStatus: '策略狀態',
  strategyName: '策略名稱',
  strategyNameRequired: '請輸入策略名稱',
  strategyNamePlaceholder: '請輸入策略名稱',
  strategyDetail: '策略詳情',
  specifyCountry: '指定國家/地區',
  specifyCountryPlaceholder: '請輸入國家/地區',
  strategyType: '策略類型',
  strategyRules: '策略規則',
  ruleType: '策略規則',
  ruleContent: '策略規則內容',
  ruleEmptyText: '暫無策略規則',
  ruleFormPlaceholder: '規則配置待補充',
  typeCountry: '指定國家/地區發獎',
  typeCountryDesc: '指定行政區域或GPS範圍內用戶可中獎',
  typeMemberLevel: '指定會員等級發獎',
  typeMemberLevelDesc: '指定會員等級的用戶可中獎',
  typeUserLimit: '單用戶指定次數發獎',
  typeUserLimitDesc: '活動週期內，任意用戶最多中獎N次',
  typeTimePeriod: '指定時間段發獎',
  typeTimePeriodDesc: '活動週期內，在指定時間段內可中獎',
  memberLevel: '會員等級',
  memberLevelPlaceholder: '請選擇會員等級',
  countryRegion: '國家/地區',
  countryPlaceholder: '請選擇國家',
  regionPlaceholder: '請選擇一級行政區',
  timePeriod: '時間週期',
  timePeriods: '時間段',
  currentActivityPeriod: '當前活動週期內',
  userLimitCount: '單用戶累計次數',
  nthLabel: '第',
  scanParticipate: '次掃碼參與',
  timeType: '時間類型',
  timeTypeDaily: '按天',
  timeTypeWeekly: '按周',
  timeTypeCustom: '指定時間範圍',
  selectWeekDays: '選擇日期',
  selectDateRange: '選擇日期',
  startDate: '開始日期',
  endDate: '結束日期',
  weekDayMon: '週一',
  weekDayTue: '週二',
  weekDayWed: '週三',
  weekDayThu: '週四',
  weekDayFri: '週五',
  weekDaySat: '週六',
  weekDaySun: '週日',
};
